import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 4a8 8 0 1 0 8 8 1 1 0 1 1 2 0A10 10 0 1 1 12 2a1 1 0 1 1 0 2",
      clipRule: "evenodd"
    }
  )
);
var SvgLoadingRedoUndoOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var LoadingRedoUndoOutlined_default = SvgLoadingRedoUndoOutlined;

export { LoadingRedoUndoOutlined_default as default };
